import { WorkspaceService } from "@/service";
import type { TWorkspace } from "@/types";
import { create } from "zustand";
import { immer } from "zustand/middleware/immer";

type TWorkspaceStore = {
   workspaces: Record<string, TWorkspace>;
   fetchWorkspaces: () => Promise<TWorkspace[]>;
   fetchWorkspace: (slug: string) => Promise<Required<TWorkspace>>;
};
const workspaceService = new WorkspaceService();
export const useWorkspaceStore = create<TWorkspaceStore>()(
   immer((set) => ({
      workspaces: {},
      fetchWorkspace: async (slug: string) => {
         const workspace = await workspaceService.getWorkspace(slug);

         set((state) => {
            state.workspaces[slug] = workspace;
         });
         return workspace;
      },
      fetchWorkspaces: async () => {
         const workspaces = await workspaceService.getWorkspaces();

         set({
            workspaces: workspaces.reduce(
               (prev, curr) => ({ ...prev, [curr.slug]: curr }),
               {},
            ),
         });
         return workspaces;
      },
   })),
);
